import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Briefcase } from "lucide-react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useBusiness = () => useContext(Ctx) || { current: "all", businesses: [], setCurrent: () => {} };

export function BusinessProvider({ children }) {
  const [businesses, setBusinesses] = useState([]);
  const [current, setCurrentState] = useState(() => localStorage.getItem("rsmart_business") || "all");
  const setCurrent = useCallback((v) => { setCurrentState(v); localStorage.setItem("rsmart_business", v); }, []);
  useEffect(() => { api.get("/admin/businesses").then((r) => setBusinesses(r.data || [])).catch(() => {}); }, []);
  return <Ctx.Provider value={{ businesses, current, setCurrent }}>{children}</Ctx.Provider>;
}

export function BusinessSwitcher() {
  const { businesses, current, setCurrent } = useBusiness();
  if (!businesses.length) return null;
  return (
    <div className="hidden sm:flex items-center gap-1.5" title="Business filter">
      <Briefcase size={15} className="text-slate-400" />
      <select data-testid="business-switcher" value={current} onChange={(e) => setCurrent(e.target.value)}
        className="text-xs font-semibold border border-slate-200 rounded-lg px-2 py-1.5 bg-white text-slate-700 max-w-[150px]">
        <option value="all">All Businesses</option>
        {businesses.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
    </div>
  );
}
